// import En from '../../Icons/LangFlags/En';
// import Es from '../Icons/LangFlags/Es';
// import Ua from '../../Icons/LangFlags/Ua';
// import Ru from '../../Icons/LangFlags/Ru';
import styles from './HeaderMiddle.module.css';
// import LangSelector from '../LangSelector/LangSelector';
import { Link } from 'react-router-dom';
import NavMenu from '../NavMenu/NavMenu';
import NavIcons from '../NavIcons/NavIcons';
import { useTranslation } from 'react-i18next';

const HeaderMiddle = () => {
  const { t } = useTranslation();

  // useEffect(() => {
  //   const lng = navigator.language;

  //   i18n.changeLanguage(lng);
  // }, []);
  return (
    <header className={styles.container} role='banner'>
      <div className={styles.header}>
        <h1>
          <Link to='/'>{t('lang.homeTitle')}</Link>
        </h1>
        <NavMenu menuMiddle='1' />

        <NavIcons />
      </div>
      {/* <div className={styles.textContainer}>
        <p>{t('lang.homeSubTitle')}</p>
      </div> */}
    </header>
  );
};

export default HeaderMiddle;
